import React, { useState, Component } from "react";

import {
    createStyles,
    Text,
    Avatar,
    TypographyStylesProvider,
    Paper,
    ActionIcon,
    Image,
    Group,
    Card,
    Button,
    NumberInput,
    ColorPicker,
    TextInput,
    Textarea,
    Stack
} from '@mantine/core';
import { Dropzone, IMAGE_MIME_TYPE } from '@mantine/dropzone';
import {
    IconFlag,
    IconCornerDownRight,
    IconSquareRoundedArrowUp,
    IconTrendingUp,
    IconCheck,
    IconX,
    IconPencil
} from '@tabler/icons';
import pagani from '../assets/pagani.jpg';
const useStyles = createStyles((theme) => ({
    colorPicker: {
        margin: '0 auto'
    },
    colorPickerLabel: {
        marginLeft: '8%'
    }
}));


//descript:modal for editing basic info about the site
//needed:styling
//needed:state integration and api calls
const BizMgmtEdit = props => {
//const PlaceBid = (message) => ({message}){
    const { classes } = useStyles();
    const [color, setColor] = useState('rgba(99, 59, 15, 0.7)');
    const iconSize = 22;
    
    return (
        <>
            <Card shadow="sm" p="lg" radius="md">
                <Card.Section>
                    <Text
                        fw={440}
                        className={classes.colorPickerLabel}
                    >
                    Theme Color Picker
                    </Text>
                    <ColorPicker
                        format="rgba"
                        value={color}
                        onChange={setColor}
                        className={classes.colorPicker}
                    />
                </Card.Section>
                <br/>
                <TextInput
                    placeholder="Company Name Here"
                    label="Company Name"
                    withAsterisk
                />
                <TextInput
                    placeholder="https://ExampleCompany.com"
                    label="Company Website"
                    withAsterisk
                />
                <br/>
                <Textarea
                    placeholder="Brief Description of Your Company"
                    label="Company About"
                />
                <br/>
                <br/>
                <Stack align="center">
                    <Dropzone
                        className={classes.dzContain}
                        multiple={false}
                        accept={IMAGE_MIME_TYPE}
                    >
                        <Button
                            leftIcon={<IconPencil size={iconSize}/>}
                            fullWidth
                        >
                        Company Logo
                        </Button>
                    </Dropzone>
                    <br/>
                    <Avatar
                        src={pagani}
                        radius="48px"
                        size={"xl"}
                    />
                </Stack>
            </Card>
        </>
    )
};
export default BizMgmtEdit;
